import { GzRemovableWebComponent } from './component/GzRemovableWebComponent';
import { WEB_COMPONENT_GZ_REMOVABLE } from '../../webcomponents.constants';

export { GzRemovableWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_REMOVABLE, GzRemovableWebComponent);

/**
 * This component will display a 'Remove' button at the right side of the element that needs to be removed. Clicking
 * the remove button doesn't remove the element from the DOM, it just emits the 'shouldRemoveItem' event. This will
 * be captured by the parent that will perform an action.
 *
 * Removable text input =>
 * <gz-removable>
 *   <gz-input type="text" placeholder="Name"></gz-input>
 * </gz-removable>
 *
 * Removable enum filter =>
 * <gz-removable>
 *   <gz-enum-filter ...props></gz-enum-filter>
 * </gz-removable>
 *
 * Setting the 'disabled' attribute on the component will disable its content as well and the component cannot be
 * removed - clicking the 'REMOVE' button will not emit the 'shouldRemoveItem' event.
 *  <gz-removable disabled>
 *   <gz-input type="text" placeholder="Name"></gz-input>
 * </gz-removable>
 *
 */
